"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommunityJoinDialog = CommunityJoinDialog;
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _TextField2 = _interopRequireDefault(require("@mui/material/TextField"));
var _DialogActions2 = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _DialogTitle2 = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Dialog3 = _interopRequireDefault(require("@mui/material/Dialog"));
var _formik = require("formik");
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _validator = _interopRequireDefault(require("validator"));
var Yup = _interopRequireWildcard(require("yup"));
var _services = require("../services");
var _button = require("./button");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function CommunityJoinDialog(_ref) {
  let {
    Button: _Button,
    Dialog: _Dialog,
    currentUser,
    geogroup,
    onClose,
    ...props
  } = _ref;
  const [hasCode, setHasCode] = (0, _react.useState)(false);
  const [emailSent, setEmailSent] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    isValid,
    isSubmitting,
    values,
    setValues,
    handleChange,
    handleSubmit
  } = (0, _formik.useFormik)({
    initialValues: {
      firstName: '',
      lastName: '',
      code: '',
      professionalEmail: ''
    },
    validationSchema: Yup.object().shape({
      firstName: Yup.string(),
      lastName: Yup.string(),
      professionalEmail: Yup.string().test(value => !value || _validator.default.isEmail(value)),
      code: Yup.string()
    }),
    validateOnMount: true,
    validateOnChange: true,
    enableReinitialize: true,
    onSubmit
  });
  (0, _react.useEffect)(() => {
    if (props.open) {
      setHasCode(!currentUser);
      setEmailSent(false);
      setValues({
        firstName: '',
        lastName: '',
        code: '',
        professionalEmail: ''
      });
    }
  }, [props.open]);
  async function onSubmit(_ref2, _ref3) {
    let {
      firstName,
      lastName,
      code,
      professionalEmail
    } = _ref2;
    let {
      setSubmitting
    } = _ref3;
    if (geogroup) {
      setSubmitting(true);
      try {
        if (geogroup.type === 'city' || geogroup.openMembership) {
          await _services.GeogroupService.joinGeogroup(geogroup.id);
          onClose(geogroup);
        } else if (geogroup.type === 'company') {
          if (hasCode) {
            if (geogroup.partner) {
              if (!geogroup.partner.whiteListedDomains || geogroup.partner.whiteListedDomains.length === 0) {
                if (currentUser) {
                  await _services.EmployeeService.createEmployee(geogroup.partner, {
                    professionalEmail: currentUser.email,
                    invitationCode: code,
                    userId: currentUser.id
                  });
                  onClose(geogroup);
                } else {
                  onClose(geogroup, {
                    invitationCode: code
                  });
                }
              } else {
                await _services.EmployeeService.createEmployee(geogroup.partner, {
                  professionalEmail,
                  invitationCode: code
                });
                setEmailSent(true);
              }
            } else {
              throw new Error('geogroup has no partner');
            }
          } else {
            await _services.GeogroupService.joinGeogroup(geogroup.id, {
              disabledRetrieval: true,
              firstName,
              lastName
            });
            onClose(geogroup, {
              partner: geogroup.partner ? {
                code: geogroup.partner.code,
                title: geogroup.partner.title,
                icon: geogroup.partner.icon
              } : null,
              waiting: true
            });
          }
        } else {
          await _services.GeogroupService.joinGeogroupWithInvitation(code, {
            geogroupId: geogroup.id
          });
          onClose(geogroup);
        }
      } catch (err) {
        if (typeof err === 'object' && err && 'status' in err && typeof err.status === 'number' && [403, 409, 412].includes(err.status)) {
          if (err.status === 403) {
            enqueueSnackbar(t('commons.communities.join_dialog.server_error_whitelist', {
              geogroupTitle: geogroup.title
            }), {
              variant: 'error'
            });
          } else if (err.status === 409) {
            enqueueSnackbar(t('commons.communities.join_dialog.server_error_already_joined'), {
              variant: 'error'
            });
          } else {
            setEmailSent(true);
          }
        } else {
          console.error(err);
          enqueueSnackbar(t('commons.communities.join_dialog.server_error_email'), {
            variant: 'error'
          });
        }
      }
      setSubmitting(false);
    }
  }
  if (!geogroup) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  const Dialog = _Dialog || _Dialog3.default;
  const Button = _Button || _button.Button;
  return /*#__PURE__*/_react.default.createElement(Dialog, _extends({
    fullWidth: true,
    disableEscapeKeyDown: isSubmitting,
    maxWidth: "xs",
    onClose: (_, reason) => (!isSubmitting || reason !== 'backdropClick') && onClose()
  }, props), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    position: "absolute",
    right: 12,
    top: 12
  }, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    title: t('commons.actions.close')
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    disabled: isSubmitting,
    onClick: () => onClose()
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null))))), /*#__PURE__*/_react.default.createElement(_DialogTitle2.default, {
    sx: {
      paddingRight: 8
    }
  }, t('commons.communities.join_dialog.title', {
    context: geogroup.type === 'company' && !hasCode ? 'ask' : geogroup.type !== 'city' && !geogroup.openMembership ? 'code' : '',
    geogroupTitle: geogroup.title
  })), emailSent ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DialogContent2.default, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary"
  }, t('commons.communities.join_dialog.email_sent')))), /*#__PURE__*/_react.default.createElement(_DialogActions2.default, null, /*#__PURE__*/_react.default.createElement(Button, {
    onClick: () => onClose(),
    size: "medium",
    variant: "contained"
  }, t('commons.actions.close')))) : /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_DialogContent2.default, null, geogroup.type === 'company' && !hasCode ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 4
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "body2"
  }, t('commons.communities.join_dialog.description_company')), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    required: true,
    disabled: isSubmitting,
    id: "firstName",
    InputLabelProps: {
      shrink: true
    },
    label: t('commons.first_name'),
    name: "firstName",
    onChange: handleChange,
    size: "small",
    value: values.firstName,
    variant: "outlined"
  }), /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    required: true,
    disabled: isSubmitting,
    id: "lastName",
    InputLabelProps: {
      shrink: true
    },
    label: t('commons.last_name'),
    name: "lastName",
    onChange: handleChange,
    size: "small",
    value: values.lastName,
    variant: "outlined"
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, geogroup.type !== 'city' && !geogroup.openMembership ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 4
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "body2"
  }, t('commons.communities.join_dialog.description_code', {
    context: geogroup.type === 'company' ? geogroup.partner && geogroup.partner.whiteListedDomains && geogroup.partner.whiteListedDomains.length > 0 ? 'email' : 'company' : ''
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    required: true,
    disabled: isSubmitting,
    id: "code",
    InputLabelProps: {
      shrink: true
    },
    label: t('commons.code'),
    name: "code",
    onChange: handleChange,
    size: "small",
    value: values.code,
    variant: "outlined"
  }), geogroup.type === 'company' && geogroup.partner && geogroup.partner.whiteListedDomains && geogroup.partner.whiteListedDomains.length > 0 && /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    required: true,
    disabled: isSubmitting,
    helperText: t('commons.professional_email_helper_restriction', {
      partnerTitle: geogroup.partner.title
    }),
    id: "professionalEmail",
    InputLabelProps: {
      shrink: true
    },
    label: t('commons.email_professional'),
    margin: "none",
    name: "professionalEmail",
    onChange: handleChange,
    size: "small",
    type: "email",
    value: values.professionalEmail,
    variant: "outlined"
  }))) : /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "body2"
  }, t('commons.communities.join_dialog.description', {
    username: currentUser?.username || ''
  })))), /*#__PURE__*/_react.default.createElement(_DialogActions2.default, null, currentUser && geogroup.type === 'company' && /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    disabled: isSubmitting,
    onClick: () => {
      setValues({
        firstName: '',
        lastName: '',
        code: '',
        professionalEmail: ''
      });
      setHasCode(!hasCode);
    },
    size: "medium",
    type: "reset",
    variant: "text"
  }, t(hasCode ? 'commons.communities.join_dialog.actions.has_no_code' : 'commons.communities.join_dialog.actions.has_code')), /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    disabled: isSubmitting || !isValid || (geogroup.type === 'company' ? hasCode ? geogroup.partner?.whiteListedDomains && geogroup.partner.whiteListedDomains.length > 0 && !values.professionalEmail || !values.code : !values.firstName || !values.lastName : geogroup.type !== 'city' && !geogroup.openMembership && !values.code),
    size: "medium",
    startIcon: isSubmitting && /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16
    }),
    type: "submit",
    variant: "contained"
  }, t(geogroup.type === 'company' && !hasCode ? 'commons.communities.join_dialog.actions.ask' : 'commons.communities.join_dialog.actions.join')))));
}